(function() {
    'use strict';

    angular
        .module('irricrops')
        .controller('vinedoAnalisisCtrl', vinedoAnalisisCtrl);

     vinedoAnalisisCtrl.$inject = ['vinedo'];

    /* @ngInject */
    function vinedoAnalisisCtrl(vinedo) {
        var vm     = this;
        vm.vinedo  = vinedo.data;
        vm.equipos = vinedo.data.equipos;

      vm.config = {
        name  : "",
        //facFn : "Vinedo",
        //equipos : vm.equipos,
        //arrayHttp : {
          //name  : "vinedo_id",
          //array : [vm.vinedo]
        //},
        http : {
          vinedo_id : vinedo.data.id,
        }
      };
    }
})();
